import React from 'react'
import { LoginForm } from 'components/index'
import styles from './Login.module.scss'
import phoneBg from 'assets/img/phone.png'

function Login() {
  return (
    <div className={styles.wrapper} style={{ backgroundImage: `url(${phoneBg})` }}>
      <div className={styles.overlay} />
      <div className={styles.content}>

        {/* Left branding */}
        <div className={styles.branding}>
          <div className={styles.heroBadge}>
            ОАО «Кыргызкомур»
          </div>
          <h1 className={styles.heroTitle}>
            Центр управления
            <br />и контроля логистики
          </h1>
          <p className={styles.heroDesc}>
            Единая цифровая платформа для оперативного отслеживания грузоперевозок,
            мониторинга маршрутов и контроля техники в режиме реального
            времени — от погрузки до доставки.
          </p>
          {/* Десктоп: внутри левой колонки */}
          <div className={styles.heroSupportDesktop}>
            <span className={styles.heroSupportIcon}>📞</span>
            <div>
              <div className={styles.heroSupportLabel}>Центр технической поддержки</div>
              <a href="tel:+996600011032" className={styles.heroSupportPhone}>+996 600 011 032</a>
            </div>
          </div>
        </div>

        {/* Right form card */}
        <div className={styles.formCard}>
          <LoginForm />
        </div>

        {/* Мобилка: после формы */}
        <div className={styles.heroSupportMobile}>
          <span className={styles.heroSupportIcon}>📞</span>
          <div>
            <div className={styles.heroSupportLabel}>Центр технической поддержки</div>
            <a href="tel:+996600011032" className={styles.heroSupportPhone}>+996 600 011 032</a>
          </div>
        </div>

      </div>
    </div>
  )
}

export default Login
